export enum AttendeeOfficeStatus {
    Free = 0,
    Busy = 1,
    Unknown = -1
}